module.exports = {
      id: "0c1946c57db676b6633077256cbfb525state-luxury.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.ba3d6e28.svg#0c1946c57db676b6633077256cbfb525state-luxury.svg",
      toString: function () {
        return this.url;
      }
    }